package com.sddamico.draftmachine.models

import kotlinx.serialization.Serializable

/** Frontend mirror of the jvmMain `models/TeamModels.kt` `TeamResponse`. */
@Serializable
data class TeamResponse(
  val id: String,
  val ownerName: String,
  val teamName: String,
  val ownerEmail: String,
)

/** Frontend mirror of the jvmMain `TeamSummary` — participant-safe team view (no owner email). */
@Serializable
data class TeamSummary(
  val id: String,
  val ownerName: String,
  val teamName: String,
)
